import moment from 'moment';

export const montaObjetoParaUpdateAssociado = associado => ({
    SubGrupo: associado.SubGrupo,
    Data: moment().add(3, 'hours').format('L'),
    Nome: associado.Nome,
    AssEmail: associado.AssEmail,
    Residencia: associado.Residencia,
    Bairro: associado.Bairro,
    Cidade: associado.Cidade, //pra esse contrato retorna 2009
    CEPResid: associado.CEPResid,
    DiaVenc: associado.DiaVenc,
    AssTipoCobranca: associado.AssTipoCobranca,
    CPF: associado.CPF,
    RG: associado.RG,
    Nascimento: associado.Nascimento,
    Sexo: associado.Sexo,
    EstadoCivil: associado.EstadoCivil,
    TipoVenda: associado.TipoVenda,
    Grupo: associado.Grupo,
    CarenAtend: associado.CarenAtend,
    CarenFuneral: associado.CarenFuneral,
    payzentipomensalidade: associado.payzentipomensalidade,
    Telefone: associado.Telefone,
    Celular: associado.Celular,
    MaeAssoc: associado.MaeAssoc,
    PaiAssoc: associado.PaiAssoc,
    Profissao: associado.Profissao,
    Complemento: associado.Complemento,
    numeroResidencia: associado.numeroResidencia,
    Obs1: associado.Obs1,
    AssReferenciaEndereco: associado.AssReferenciaEndereco,
    AssReferenciaEnderecoCobranca: associado.AssReferenciaEnderecoCobranca,
    Origem: associado.Origem,
    Obs2: associado.Obs2,
    unidade_trabalho_vendedor: associado.unidade_trabalho_vendedor,
    valor_base: associado.valor_base,
    Carencia: associado.Carencia,
    DescricaoCarencia: associado.DescricaoCarencia,
    Promocional: associado.Promocional,
    idCemiterio: associado.idCemiterio,
    idDescontoEspecial : associado.idDescontoEspecial
});
